module.exports = __webpack_public_path__ + "static/img/sfe-icon.3830a6d4.png";